import React from "react";

import Box from "../Box";
import Text from "../Text";

function ShutdownBanner() {
  return (
    <Box bg="pink" py="12px" px={2} textAlign="center">
      <Text
        color="green"
        fontFamily="roboto"
        fontWeight="medium"
        style={{ fontSize: "14px" }}
      >
        Greenlist has shut down and is no longer available. Thank you for being
        part of the journey.
      </Text>
    </Box>
  );
}

export default ShutdownBanner;
